import './index.less';
import { Jlzx } from '@/assets/svg-icon';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import BadgeUI from '@/componentsUI/Badge';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useNavigate } from 'react-router';
import { useGlobalState, useMobileLeftSiderSwitch } from '@/store/commonStore';
import useDialogManager from '@/utils/useDialogManager';
import { useActivityEntryPlus } from '@/store/home';
import { useWsUpdateBouns } from '@/store/hallSocket';

const BonusItem = (props) => {
  const { className, isSelect } = props;
  const prefixCls = 'bonus-menu-item';
  const { t } = useTranslationPlus('HomeView');
  const navigate = useNavigate();
  const { isLogin } = useGlobalState();
  const { openSignIn } = useDialogManager();
  const [drawerVisible, setDrawerVisible] = useMobileLeftSiderSwitch();

  const { data, mutate } = useActivityEntryPlus();


  const {data: wsData} = useWsUpdateBouns()

  useEffect(()=>{
    if(wsData) {
      mutate()
    }
  },[wsData])

  return (
    <div
      className={classNames([prefixCls, className, isSelect ? `${prefixCls}-check` : ''])}
      onClick={() => {
        setDrawerVisible(false);
        if (isLogin) {
          navigate('/bonus');
        } else {
          openSignIn();
        }
      }}
    >
      {/* <div className={`${prefixCls}-item ${prefixCls}-tigger`}> */}
      <BadgeUI count={data?.giftBagStatus ? 1 : 0} dot className={`${prefixCls}-item ${prefixCls}-tigger`}>
        <div className="item-left">{<Jlzx />}</div>
        <div className="item-right">
          <span>{t('Bonus')}</span>
        </div>
      </BadgeUI>
      {/* </div> */}
    </div>
  );
};

export default BonusItem;
